import { api } from './api';

/** Dati del mittente stampati in testa ai documenti d'ordine. */
export interface DatiAzienda {
  id?: number;
  ragioneSociale: string;
  indirizzo?: string;
  cap?: string;
  citta?: string;
  provincia?: string;
  partitaIva?: string;
  codiceFiscale?: string;
  telefono?: string;
  email?: string;
  sitoWeb?: string;
  noteDocumento?: string;
}

/** Restituisce i dati azienda, o null se non sono ancora stati compilati. */
const getDatiAzienda = async (): Promise<DatiAzienda | null> => {
  const response = await api.get<DatiAzienda>('/dati-azienda', {
    validateStatus: (s) => s === 200 || s === 204,
  });
  return response.status === 204 ? null : response.data;
};

const saveDatiAzienda = async (dati: DatiAzienda): Promise<DatiAzienda> => {
  const response = await api.put<DatiAzienda>('/dati-azienda', dati);
  return response.data;
};

export default {
  getDatiAzienda,
  saveDatiAzienda,
};
